import { logoVector } from "@/lib/assets";
import { AdminThemeScope } from "@/shared/design-system/admin/AdminThemeScope";

/**
 * Full-screen fallback shown while lazy route chunks load. Renders inside
 * `AdminThemeScope` so the canvas and the rotating Evangelist mark follow the
 * stored light/dark preference; the mark flips to solid white in dark mode the
 * same way the shared `Logo` does.
 */
export const AppLoadingScreen = () => (
  <AdminThemeScope className="flex min-h-svh w-full items-center justify-center bg-(--color-background)">
    <div className="size-16 animate-spin" role="status" aria-label="Loading">
      <img
        src={logoVector}
        alt=""
        className="h-full w-full object-contain dark:brightness-0 dark:invert"
        loading="eager"
        decoding="async"
      />
    </div>
  </AdminThemeScope>
);
